import api from '@/api/axios';

const state = {
  notificationList: [],
  notificationChannelList: [],
  notificationReceiverList: [],
  notificationAnomalyTypeList: [],
  notificationCrawlingList: [],
  selectedProject: null,  
  notificationDetail: null, // 개별 상세 데이터를 저장할 상태 추가
  notificationComment: null,
  isLoading: false,
  error: null,
};

const mutations = {
  SET_NOTIFICATION_LIST(state, notificationList) {
    state.notificationList = notificationList;
  },
  SET_NOTIFICATION_CHANNEL(state, notificationChannelList) {
    state.notificationChannelList = notificationChannelList;
  },
  SET_NOTIFICATION_RECEIVERS(state, notificationReceiverList) {
    state.notificationReceiverList = notificationReceiverList;
  },
  SET_NOTIFICATION_ANOMALY_TYPE(state, notificationAnomalyTypeList) {
    state.notificationAnomalyTypeList = notificationAnomalyTypeList;
  },
  SET_NOTIFICATION_CRAWLING(state, notificationCrawlingList) {
    state.notificationCrawlingList = notificationCrawlingList;
  },
  REMOVE_NOTIFICATION_FROM_LIST(state, notification_id) {
    state.notificationList = state.notificationList.filter(
      item => item.notification_id !== notification_id
    );
  },
  setSelectedProject(state, project) {
      state.selectedProject = project
  },
   
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }, 
};

const actions = {
  // 키워드알림 MST 조회
  async fetchNotificationList({ commit, rootState }, project_id) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      const response = await api.get(`/api/v1/notification/notification_list/${project_id}`);
      console.log('response', response.data);
      commit('SET_NOTIFICATION_LIST', response.data);
    } catch (error) {
      console.error('Failed to fetch fetchNotificationList:', error);
      if (error.response && error.response.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || 'Failed to fetch QA list');
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // 키워드알림 DTL 조회
  async fetchNotificationDtlList({ commit, rootState }, { notification_id, project_id,participants }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      } 

      // 📌 채널 조회
      const channelResponse = await api.get(`/api/v1/notification/notification_channel_list/${notification_id}`); 
      commit('SET_NOTIFICATION_CHANNEL', channelResponse.data);

      // 📌 이상 유형 조회
      const anomalyTypeResponse = await api.get(`/api/v1/notification/notification_anomaly_type_list/${notification_id}`);
      commit('SET_NOTIFICATION_ANOMALY_TYPE', anomalyTypeResponse.data);

      // ✅ 수신자 목록 조회
      const receiverResponse = await api.get('/api/v1/notification/notification_receiver_list', {
        params: {
          project_id: project_id,
          notification_id: notification_id,
          participants, 
        }
      }); 
      commit('SET_NOTIFICATION_RECEIVERS', receiverResponse.data);

      // 📌 실시간 크롤링 리스트 
      const crawlingResponse = await api.get('/api/v1/notification/notification_crawling_list', {
        params: {
          project_id: project_id,
          notification_id: notification_id
        }
      }); 
      commit('SET_NOTIFICATION_CRAWLING', crawlingResponse.data);
 

    } catch (error) {
      console.error(`Failed to notification_channel_list (notification_id: ${notification_id}):`, error);
      if (error.response && error.response.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || `Failed to notification_channel_list (notification_id: ${notification_id})`);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  
  // 🔧 Notification 삭제 + 리스트 재조회 액션
  async saveDelNotificationList({ commit, rootState }, { notification_id, project_id }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }

      // 🔸 DELETE 요청
      console.log('🧪 삭제 요청 notification_id:', notification_id); 
      await api.delete(`/api/v1/notification/delNotification/${notification_id}`);
      console.log(`✅ notification_id=${notification_id} 삭제 완료`);

      // 🔸 mutation으로 로컬 목록에서 제거 (선택적)
      commit('REMOVE_NOTIFICATION_FROM_LIST', notification_id);

      return true;
    } catch (error) {
      console.error('삭제 실패:', error);
      if (error.response && error.response.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || '삭제 요청 실패');
      return false;
    } finally {
      commit('SET_LOADING', false);
    }
  }, 
  
  // 🔧 Notification 수정
  async saveUpdateNotificationList({ commit, rootState }, { mst_row, Crawling, Project, Anomalies, Channels, craKeywords, startDt, endDt }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }

      const notification_id = mst_row.notification_id; 
      const rowsCrawling = Crawling.value;
      const project = Project.value;
      const anomalies = Anomalies.value;
      const channels = Channels.value;
      const keywords = craKeywords.value;
      const startDate = startDt.value;
      const endDate = endDt.value; 

      // 🔸 POST 요청으로 수정 API 호출
      await api.post(`/api/v1/notification/updateCrawlingData/${notification_id}`, {
        rowsCrawling: rowsCrawling,  // [{ job_id, selected }]
        project: project,
        anomalies: anomalies,
        channels: channels,
        keywords: keywords,
        start_date: startDate,
        end_date: endDate,
      });

      console.log(`✅ notification_id=${notification_id} 업데이트 완료`);

      return true;
    } catch (error) {
      console.error('❌ 수정 실패:', error);
      if (error.response && error.response.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || '수정 요청 실패');
      return false;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  
  // 키워드알림 등록화면 조회
  async fetchNotificationRegisterList({ commit, rootState }, { project_id, participants }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      } 

      // 📌 채널 조회
      const channelResponse = await api.get(`/api/v1/notification/notification_register_channel_list`); 
      commit('SET_NOTIFICATION_CHANNEL', channelResponse.data);

      // 📌 이상 유형 조회
      const anomalyTypeResponse = await api.get(`/api/v1/notification/notification_register_anomaly_type_list`);
      commit('SET_NOTIFICATION_ANOMALY_TYPE', anomalyTypeResponse.data);
      
      // ✅ 수신자 목록 조회
      const receiverResponse = await api.get('/api/v1/notification/notification_register_receiver_list', {
        params: { 
          participants, 
        }
      }); 
      commit('SET_NOTIFICATION_RECEIVERS', receiverResponse.data);

    

      // 📌 실시간 크롤링 리스트 
      const crawlingResponse = await api.get('/api/v1/notification/notification_register_crawling_list', {
        params: {
          project_id: project_id, 
        }
      }); 
      commit('SET_NOTIFICATION_CRAWLING', crawlingResponse.data);
 

    } catch (error) {
      console.error(`Failed to fetchNotificationRegisterList`, error);
      if (error.response && error.response.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || `Failed to fetchNotificationRegisterList`);
    } finally {
      commit('SET_LOADING', false);
    }
  },
 
  // 🔧 Notification 신규등록
  async saveInsertNotificationList({ commit, rootState }, {  Crawling, Project, Anomalies, Channels, craKeywords, startDt, endDt }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
 
      const rowsCrawling = Crawling.value;
      const project = Project.value;
      const anomalies = Anomalies.value;
      const channels = Channels.value;
      const keywords = craKeywords.value;
      const startDate = startDt.value;
      const endDate = endDt.value; 

      // 🔸 POST 요청으로 수정 API 호출
      await api.post(`/api/v1/notification/insertCrawlingData`, {
        rowsCrawling: rowsCrawling,  // [{ job_id, selected }]
        project: project,
        anomalies: anomalies,
        channels: channels,
        keywords: keywords,
        start_date: startDate,
        end_date: endDate,
      });

      console.log(`✅ 신규 저장완료`);

      return true;
    } catch (error) {
      console.error('❌ 수정 실패:', error);
      if (error.response && error.response.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || '수정 요청 실패');
      return false;
    } finally {
      commit('SET_LOADING', false);
    }
  },

}; 

const getters = {
  allNotificationList : state => state.notificationList,
  allAnomalyTypeList : state => state.notificationAnomalyTypeList,
  allChannelList : state => state.notificationChannelList,
  allReceiverList : state => state.notificationReceiverList,
  allCrawlingList : state => state.notificationCrawlingList,  
  isLoading: state => state.isLoading,
  error: state => state.error,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
